<template>
    <div >
      <table class="w-full text-sm text-left rtl:text-right text-black">
        <thead class="text-xs uppercase bg-gray-300 text-center text-black border-b border-gray-700 ">
          <tr>
            <th v-for="(header, index) in headers" :key="index" class="px-6 py-3">
              {{ header }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, rowIndex) in body" :key="rowIndex" class="bg-white border-b bg-gray-200  border-gray-700">
            <td v-for="(cell, cellIndex) in row" :key="cellIndex" class="px-2 py-4" :class="{ 'font-medium text-black whitespace-nowrap': cellIndex === 0 }">
            


            <template v-if="cellIndex === 'implementar'">             
              <div class="flex justify-center flex flex-col gap-3 items-center w-full h-full">
                <svg xmlns="http://www.w3.org/2000/svg"  class="w-4 cursor-pointer" @click="irParaLink(cell)" viewBox="0 0 576 512"><!--! Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) Copyright 2024 Fonticons, Inc. --><path d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z"/></svg>

                <svg xmlns="http://www.w3.org/2000/svg" class="w-4 cursor-pointer" @click="handleClick(cell)" viewBox="0 0 512 512"><!--! Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) Copyright 2024 Fonticons, Inc. --><path d="M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1v32c0 8.8 7.2 16 16 16h32zM362.7 18.7L348.3 33.2 325.7 55.8 314.3 67.1l33.9 33.9 62.1 62.1 33.9 33.9 11.3-11.3 22.6-22.6 14.5-14.5c25-25 25-65.5 0-90.5L453.3 18.7c-25-25-65.5-25-90.5 0zm-47.4 168l-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l144-144c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"/></svg>
  
            </div>
            </template>

            <template v-if="cellIndex!== 'implementar' && cellIndex!== 'copiar'">
              {{ cell }}
            </template>
          </td>
          </tr>
        </tbody>
      </table>
    </div>
  </template>
  
  <script>
  import router from "@/router/routes.js"

  export default {
    name: 'TableDiagnostico',
    props: {
      headers: {
        type: Array,
        required: true
      },
      body: {
        type: Array,
        required: true
      }
    },
    methods: {
    handleClick(details) {
      this.$emit('showDetails', details);
    },
    irParaLink(slug){
        router.push({ name: 'DiagnosticoController', params: { id: slug.slug } })
    }
  }
  };
  </script>

  